import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950">
      <div className="container-page py-14">
        <div className="bg-background-200/80 rounded-lg px-8 py-10">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-1/4">
              <Link to="/" className="flex items-center gap-2 cursor-pointer mb-4">
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-alert-fill text-primary-500 text-xl"></i>
                </span>
                <span className="text-foreground-950 font-bold text-lg font-heading">
                  17吃瓜
                </span>
              </Link>
              <p className="text-secondary-500 text-sm leading-relaxed">
                17吃瓜是国内领先的网红八卦与娱乐黑料实时更新平台，提供最新最全的吃瓜资讯入口。关注17吃瓜，吃瓜不迷路。
              </p>
            </div>

            <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
              <div>
                <h4 className="text-foreground-800 text-sm font-semibold mb-4">热门分类</h4>
                <div className="flex flex-col gap-2.5">
                  <Link to="/category/wanghong-heiliao" className="text-secondary-500 text-sm hover:text-foreground-950 transition-colors cursor-pointer">网红黑料</Link>
                  <Link to="/category/mingxing-tafang" className="text-secondary-500 text-sm hover:text-foreground-950 transition-colors cursor-pointer">明星塌房</Link>
                  <Link to="/category/zhibo-chigua" className="text-secondary-500 text-sm hover:text-foreground-950 transition-colors cursor-pointer">直播吃瓜</Link>
                  <Link to="/category/yule-bagua" className="text-secondary-500 text-sm hover:text-foreground-950 transition-colors cursor-pointer">娱乐八卦</Link>
                </div>
              </div>

              <div>
                <h4 className="text-foreground-800 text-sm font-semibold mb-4">关于我们</h4>
                <div className="flex flex-col gap-2.5">
                  <Link to="/about" className="text-secondary-500 text-sm hover:text-foreground-950 transition-colors cursor-pointer">品牌介绍</Link>
                  <Link to="/about" className="text-secondary-500 text-sm hover:text-foreground-950 transition-colors cursor-pointer">联系我们</Link>
                  <Link to="/about" className="text-secondary-500 text-sm hover:text-foreground-950 transition-colors cursor-pointer">爆料投稿</Link>
                </div>
              </div>

              <div>
                <h4 className="text-foreground-800 text-sm font-semibold mb-4">友情链接</h4>
                <div className="flex flex-col gap-2.5">
                  <a href="#" className="text-secondary-500 text-sm hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">17吃瓜网</a>
                  <a href="#" className="text-secondary-500 text-sm hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">17吃瓜爆料</a>
                  <a href="#" className="text-secondary-500 text-sm hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">17黑料吃瓜</a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-primary-500/30">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="text-secondary-500 text-xs flex flex-wrap items-center gap-2">
                <span>&copy; 2026 17吃瓜 版权所有</span>
                <span className="hidden sm:inline text-secondary-600">|</span>
                <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
                <span className="hidden sm:inline text-secondary-600">|</span>
                <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
                <span className="hidden sm:inline text-secondary-600">|</span>
                <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
              </div>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-500/20 hover:bg-primary-500/30 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-foreground-600 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-500/20 hover:bg-primary-500/30 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-foreground-600 text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}